// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"8b450bc2","364":"99e31ad6","637":"10a35d93","706":"e30e194e","787":"1704ddcc"}[chunkId] + ".chunk.js";
};